import { IMPERSONATOR_USER_ID_STORAGE_KEY } from './constants';

/** Read the stored admin id, answering `undefined` when it is absent or storage throws. */
export const readImpersonatorUserId = (): string | undefined => {
  try {
    return globalThis.localStorage.getItem(IMPERSONATOR_USER_ID_STORAGE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
};
